import { render } from "./attributeHomePage.vue?vue&type=template&id=7de6510a&scoped=true"
import script from "./attributeHomePage.vue?vue&type=script&lang=js"
export * from "./attributeHomePage.vue?vue&type=script&lang=js"

import "./attributeHomePage.vue?vue&type=style&index=0&id=7de6510a&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src4154090898/src/platform-insurance-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7de6510a"]])

export default __exports__